import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(public  afAuth:  AngularFireAuth, private  authService:  AuthService ,public  router:  Router) {}

  ngOnInit() {
      this.afAuth.auth.signOut();
      this.router.navigate(['']);
    
  }

}
